<template>
  <div class="site" @mousemove="onMouseMove">
    <div class="progress" :style="{ width: `${scrollProgress}%` }"></div>
    <div class="bg-orb orb-1"></div>
    <div class="bg-orb orb-2"></div>
    <div class="bg-grid"></div>
    <div class="bg-particles">
      <span v-for="i in 16" :key="i" :style="particleStyle(i)"></span>
    </div>

    <header class="topbar">
      <div class="brand-wrap">
        <div class="brand">禅意社</div>
      </div>
      <nav class="nav">
        <a href="#home">首页</a>
        <a href="#about">公司介绍</a>
        <a href="#services">产品服务</a>
        <a href="#compliance">合规安全</a>
        <a href="#contact">联系方式</a>
        <a href="/privacy-policy.html" target="_blank" rel="noreferrer noopener">隐私政策</a>
      </nav>
    </header>

    <section id="home" class="hero section reveal" :style="heroStyle">
      <div class="hero-text">
        <p class="kicker">东方文化内容产品 · 静心记录型应用</p>
        <h1>心安便是归处 <span class="glow-word">让每次静心与记录都有落点</span></h1>
        <p>
          禅意社围绕“静心、记录、文化内容、陪伴”构建沉浸式产品体验，
          通过视觉、音效和轻交互帮助用户进行日常放松、专注练习与个人内容记录。
        </p>
        <div class="hero-actions">
          <a class="btn primary" href="#services">查看功能矩阵</a>
          <a class="btn ghost" href="#compliance">查看合规能力</a>
        </div>
        <div class="hero-metrics">
          <div v-for="item in metrics" :key="item.label" class="metric">
            <strong>{{ item.value }}</strong>
            <span>{{ item.label }}</span>
          </div>
        </div>
      </div>

      <div class="hero-images">
        <div class="phone-card floating fast tilt">
          <img src="/home-screen-new.png" alt="禅意社应用首页新版" />
        </div>
        <div class="phone-card floating slow tilt">
          <img src="/detail-screen-new.png" alt="禅意社应用详情页新版" />
        </div>
      </div>
    </section>

    <section id="about" class="section card reveal">
      <div class="title-row">
        <h2>公司介绍</h2>
        <span class="tag">About Us</span>
      </div>
      <p>
        安徽云汐网络科技有限公司专注于文化内容与移动互联网产品融合创新，
        以用户体验、内容价值、信息安全为核心，持续打造长期可运营的数字文化产品。
      </p>
      <div class="timeline">
        <div v-for="item in timeline" :key="item.year" class="timeline-item">
          <span class="year">{{ item.year }}</span>
          <div>
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </div>
        </div>
      </div>
    </section>

    <section id="services" class="section card reveal">
      <div class="title-row">
        <h2>产品 / 服务介绍</h2>
        <span class="tag">Product & Service</span>
      </div>
      <div class="grid">
        <article v-for="item in services" :key="item.title" class="service-card">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
      <div class="flow">
        <div class="flow-item" v-for="step in flow" :key="step.step">
          <span>{{ step.step }}</span>
          <h3>{{ step.title }}</h3>
          <p>{{ step.desc }}</p>
        </div>
      </div>
    </section>

    <section id="compliance" class="section card reveal">
      <div class="title-row">
        <h2>合规与安全</h2>
        <span class="tag">Compliance</span>
      </div>
      <div class="legal-grid">
        <article v-for="item in legal" :key="item.title" class="legal-card">
          <h3>{{ item.title }}</h3>
          <p>{{ item.desc }}</p>
        </article>
      </div>
      <div class="notice">
        <p>
          温馨提示：禅意社定位为文化内容体验与日常放松工具，不提供医疗诊断、心理治疗、功效承诺，
          也不提供宗教募捐、算命占卜或封建迷信相关服务。如遇心理健康危机，请及时联系专业医疗机构或当地应急服务。
        </p>
      </div>
    </section>

    <section id="contact" class="section card reveal">
      <div class="title-row">
        <h2>联系方式</h2>
        <span class="tag">Contact</span>
      </div>
      <div class="contact-grid">
        <div class="contact-item">
          <span>公司名称</span>
          <strong>安徽云汐网络科技有限公司</strong>
        </div>
        <div class="contact-item">
          <span>联系电话</span>
          <strong>13817764756</strong>
        </div>
        <div class="contact-item">
          <span>联系邮箱</span>
          <strong>1373833018@qq.com</strong>
        </div>
        <div class="contact-item">
          <span>投诉与举报受理邮箱</span>
          <strong>1373833018@qq.com</strong>
        </div>
      </div>
    </section>

    <section id="privacy" class="section card reveal">
      <div class="title-row">
        <h2>隐私政策</h2>
        <span class="tag">Privacy</span>
      </div>
      <p>
        禅意社 App 隐私政策已整理为单独页面，适用于 App Store 审核、公示和用户查阅。
        页面包含数据收集类型、使用目的、系统权限、第三方共享、用户权利、未成年人保护及联系方式等完整信息。
      </p>
      <div class="hero-actions">
        <a class="btn primary" href="/privacy-policy.html" target="_blank" rel="noreferrer noopener">
          查看完整隐私政策
        </a>
      </div>
    </section>

    <footer class="footer">
      <p>© {{ year }} 安徽云汐网络科技有限公司 保留所有权利</p>
      <p class="record-line">
        ICP 备案号：
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noreferrer noopener">
          皖ICP备2026015980号-1
        </a>
      </p>
    </footer>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue'

const year = new Date().getFullYear()
const mouseX = ref(0.5)
const mouseY = ref(0.5)
const scrollProgress = ref(0)

const metrics = [
  { value: '7 x 24', label: '静心记录可用' },
  { value: '6+', label: '核心功能模块' },
  { value: '100%', label: '隐私条款公开' }
]

const timeline = [
  { year: '2024', title: '产品立项', desc: '完成文化内容场景定义与首版体验设计。' },
  { year: '2025', title: '体验升级', desc: '完善静心练习与内容记录流程，优化交互反馈。' },
  { year: '2026', title: '品牌官网升级', desc: '上线合规导向官网，强化公开透明与服务触达。' }
]

const services = [
  { title: '静心练习体验', desc: '提供适合碎片化场景的静心、呼吸与专注交互体验。' },
  { title: '个人记录空间', desc: '支持用户记录当下感受、想法与阶段变化，便于回顾整理。' },
  { title: '文化内容浏览', desc: '围绕节气、美学与传统文化主题，持续更新图文内容。' },
  { title: '会员与权益说明', desc: '展示订阅权益、服务说明、自动续费规则与取消路径。' },
  { title: '匿名统计与优化', desc: '仅在必要范围内进行匿名化数据统计，用于产品优化。' },
  { title: '客服与申诉处理', desc: '提供问题反馈、投诉举报与账号相关诉求处理通道。' }
]

const flow = [
  { step: '01', title: '进入静心场景', desc: '通过首页入口进入安静、轻量的内容体验空间。' },
  { step: '02', title: '完成当次练习', desc: '进行呼吸、轻触反馈、文字记录等核心互动。' },
  { step: '03', title: '保存个人记录', desc: '查看历史记录与阶段变化，形成连续的自我观察。' },
  { step: '04', title: '浏览主题内容', desc: '按主题获取内容更新与活动通知，保持持续参与。' }
]

const legal = [
  { title: '个人信息保护法合规', desc: '遵循合法、正当、必要和诚信原则，建立用户授权与撤回机制。' },
  { title: '网络安全与数据安全治理', desc: '建立访问控制、日志审计、传输加密与安全巡检制度。' },
  { title: '必要个人信息范围管理', desc: '核心功能可在最小信息前提下运行，不强制索取无关权限。' },
  { title: '未成年人网络保护', desc: '落实未成年人使用提示、时间管理与不良信息防护策略。' },
  { title: '订阅与付费透明', desc: '如提供会员服务，将清晰披露价格、周期、续费规则和取消方式。' },
  { title: '投诉举报机制', desc: '公开联系方式，按流程受理用户申诉、投诉、内容下架与删除请求。' }
]

const onMouseMove = (event) => {
  mouseX.value = event.clientX / window.innerWidth
  mouseY.value = event.clientY / window.innerHeight
}

const onScroll = () => {
  const scrollTop = window.scrollY
  const pageHeight = document.documentElement.scrollHeight - window.innerHeight
  scrollProgress.value = pageHeight > 0 ? (scrollTop / pageHeight) * 100 : 0
}

const heroStyle = computed(() => ({
  '--mx': `${mouseX.value}`,
  '--my': `${mouseY.value}`
}))

const particleStyle = (i) => ({
  left: `${(i * 7) % 100}%`,
  animationDelay: `${i * 0.7}s`,
  animationDuration: `${7 + (i % 5)}s`
})

onMounted(() => {
  window.addEventListener('scroll', onScroll, { passive: true })
  onScroll()
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
